module.exports = __webpack_public_path__ + "img/bg-power.837023e0.png";